import React, {Component} from 'react';

/** 首页 **/
import IndexPage from './indexPage/index';

//后台账号
import AccountList from './navigationPages/accountManage/AccountList';
import AddAccount from './navigationPages/accountManage/AddAccount';

//公司管理
import CompanyList from './navigationPages/accountManage/Company';

//企业管理
import CorporationList from './navigationPages/accountManage/Corporation';

//用户管理
import AccountPersonal from './navigationPages/accountManage/AccountPersonal';

//系统配置
import SystemSet from './navigationPages/systemManage/SystemSet';

//设备统计图表
import DeviceStaticsChart from "./navigationPages/deviceStatics/DeviceStaticsChart";
import DeviceBusinessStatics from "./navigationPages/deviceStatics/DeviceBusinessStatics";
import DeviceHealthyChart from "./navigationPages/deviceStatics/DeviceHealthyChart";

//新心跳设备列表
import DeviceStaticsList from "./navigationPages/deviceStatics/DeviceStaticsList";
import DeviceStaticsDetail from "./navigationPages/deviceStatics/DeviceStaticsDetail";

//仪表板主题
import DashboardThemeList from "./navigationPages/dashboardThemeManage/DashboardThemeList";
//内置查询
import BuiltInQueryList from "./navigationPages/registOpenApi/OpenApiList";

//设备和安装包
import DeviceList from './navigationPages/deviceManage/DeviceList';
import DeviceShare from "./navigationPages/deviceManage/DeviceShare";
import SeparationList from "./navigationPages/deviceManage/SeparationList";
import DeviceShareRules from "./navigationPages/deviceManage/DeviceShareRules";
import PackageAndroid from "./navigationPages/packageManage/PackageAndroid";
import VersionList from "./navigationPages/packageManage/version/VersionList";
import VersionAdd from "./navigationPages/packageManage/version/VersionAdd";
import UpdateTest from "./navigationPages/packageManage/testManage/UpdateTest";
import UploadPackage from "./navigationPages/packageManage/UploadPackage";
import IPFSWhiteList from "./navigationPages/packageManage/IPFSWhiteList";
import DeviceAdd from './navigationPages/deviceManage/DeviceAdd';
import DeviceUnbind from './navigationPages/deviceManage/DeviceUnbind';
import SystemLogList from './navigationPages/logManage/SystemLogList';
import ShardDelDeviceConfig from './navigationPages/deviceManage/ShardDelDeviceConfig';
import HardwareUpdateNotification from './navigationPages/packageManage/hardwareUpdateMange/index';

//ESIM
import ESIMList from "./navigationPages/esimManage/ESIMList";
import ESIMMessageList from "./navigationPages/esimManage/ESIMMessageList";

// 独享ESIM
import ESIMPrivateList from "./navigationPages/esimManage/ESIMPrivateList";

// import ESIMMessageList from "./navigationPages/esimManage/ESIMMessageList";

// ESIM 黑名单 -->  改为SIM列表
import ESIMBlackList from "./navigationPages/esimManage/ESIMBlackList";

//回收站
import ESIMRecycleList from "./navigationPages/esimManage/ESIMRecycleList";

//终端列表
import RomRuleManage from "./navigationPages/romManage/RomRuleManage.js";

//仪表板模板
import DashboardModelList from "./navigationPages/dashboardThemeManage/DashboardModelList";

//自定义组件管理
import CustomComponentsList from "./navigationPages/dashboardThemeManage/CustomComponentsList";

//系统组件管理
import SystemComponentsList from "./navigationPages/dashboardThemeManage/SystemComponentsList";

//其它后台入口
import OtherSysNavPage from "./navigationPages/otherSysNav/OtherSysNavPage";

//咨询工单管理
import ConsultList from "./navigationPages/consultManage/ConsultList";

//官网动态内容管理
import CommentList from "./navigationPages/websiteDynamicManage/CommentList";
import BuyMsgList from "./navigationPages/websiteDynamicManage/BuyMsgList";

//商品推荐管理
import PositionList from "./navigationPages/goodsManage/PositionList";
import SkillList from "./navigationPages/goodsManage/SkillList";

//商业运营管理
import GoodsPriceSet from "./navigationPages/businessOperation/GoodsPriceSet";
import VipPriceSet from "./navigationPages/businessOperation/VipPriceSet";
import RechargeSet from "./navigationPages/businessOperation/RechargeSet";

//平台协议目录
import ProtocolDirectory from "./navigationPages/protocolManage/ProtocolDirectory";
import ProtocolEdit from "./navigationPages/protocolManage/ProtocolEdit";

//审核
import WithdrawDepositAudit from "./navigationPages/auditManage/WithdrawDepositAudit";
//举报
import ReportListPage from "./navigationPages/auditManage/ReportList";

// 模型管理
import ModelListPage from "./navigationPages/modelManage/ModelList";

module.exports = {
    getView(props) {
        return [
            {
                path: "IndexPage",
                component: <IndexPage {...props} />
            },
            {
                path: "AccountList",
                component: <AccountList {...props} />
            },
            {
                path: "AddAccount",
                component: <AddAccount {...props} />
            },
            {
                path: "CompanyList",
                component: <CompanyList {...props} />
            },
            {
                path: "CorporationList",
                component: <CorporationList {...props} />
            },
            {
                path: "UserList",
                component: <AccountPersonal {...props} />
            },
            {
                path: "DeviceList",
                component: <DeviceList {...props}/>
            },
            {
                path: "IndexPage",
                component: <IndexPage {...props} />
            },
            {
                path: "AccountList",
                component: <AccountList {...props} />
            },
            {
                path: "AddAccount",
                component: <AddAccount {...props} />
            },
            {
                path: "DeviceList",
                component: <DeviceList {...props}/>
            },
            {
                path: "DeviceShare",
                component: <DeviceShare {...props}/>
            },
            {
                path: "DeviceAdd",
                component: <DeviceAdd {...props}/>
            },
            {
                path: "DeviceUnbind",
                component: <DeviceUnbind {...props}/>
            },
            {
                path: "SeparationList",
                component: <SeparationList {...props}/>
            },
            {
                path: "AccountPersonal",
                component: <AccountPersonal {...props}/>
            },
            {
                path: "DeviceShareRules",
                component: <DeviceShareRules {...props}/>
            },
            {
                path: "PackageAndroid",
                component: <PackageAndroid {...props}/>
            },
            {
                path: "VersionList",
                component: <VersionList {...props}/>
            },
            {
                path: "VersionAdd",
                component: <VersionAdd {...props}/>
            },
            {
                path: "UpdateTest",
                component: <UpdateTest {...props}/>
            },
            {
                path: "HardwareUpdateNotification",
                component: <HardwareUpdateNotification {...props}/>
            },
            {
                path: "UploadPackage",
                component: <UploadPackage {...props}/>
            },
            {
                path: "SystemLogList",
                component: <SystemLogList {...props} />
            },
            {
                path: "SystemSet",
                component: <SystemSet {...props} />
            },
            {
                path: "DeviceStaticsChart",
                component: <DeviceStaticsChart {...props} />
            },
            {
                path: "DeviceBusinessStatics",
                component: <DeviceBusinessStatics {...props} />
            },
            {
                path: "DeviceHealthyChart",
                component: <DeviceHealthyChart {...props} />
            },
            {
                path: "DeviceStaticsList",
                component: <DeviceStaticsList {...props} />
            },
            {
                path: "DeviceStaticsDetail",
                component: <DeviceStaticsDetail {...props} />
            },
            {
                path: "DashboardThemeList",
                component: <DashboardThemeList {...props} />
            },
            {
                path: "BuiltInQueryList",
                component: <BuiltInQueryList {...props} />
            },
            {
                path: "IPFSWhiteList",
                component: <IPFSWhiteList {...props} />
            },
            {
                path: "ShardDelDeviceConfig",
                component: <ShardDelDeviceConfig {...props} />
            },
            {
                path: "ESIMList",
                component: <ESIMList {...props} />
            },
            {
                path: "ESIMPrivateList",
                component: <ESIMPrivateList {...props} />
            },
            {
                path: "ESIMBlackList",
                component: <ESIMBlackList {...props} />
            },
            {
                path: "ESIMRecycleList",
                component: <ESIMRecycleList {...props} />
            },
            {
                path: "ESIMMessageList",
                component: <ESIMMessageList {...props} />
            },
            {
                path: "RomRuleManage",
                component: <RomRuleManage {...props} />
            },
            {
                path: "DashboardModelList",
                component: <DashboardModelList {...props} />
            },
            {
                path: "CustomComponentsList",
                component: <CustomComponentsList {...props} />
            },
            {
                path: "SystemComponentsList",
                component: <SystemComponentsList {...props} />
            },
            {
                path: "OtherSysNavPage",
                component: <OtherSysNavPage {...props} />
            },
            {
                path: "PositionList",
                component: <PositionList {...props} />
            },
            {
                path: "SkillList",
                component: <SkillList {...props} />
            },
            {
                path: "ConsultList",
                component: <ConsultList {...props} />
            },
            {
                path: "CommentList",
                component: <CommentList {...props} />
            },
            {
                path: "BuyMsgList",
                component: <BuyMsgList {...props} />
            },
            {
                path: "GoodsPriceSet",
                component: <GoodsPriceSet {...props} />
            },
            {
                path: "VipPriceSet",
                component: <VipPriceSet {...props} />
            },
            {
                path: "RechargeSet",
                component: <RechargeSet {...props} />
            },
            {
                path: "ProtocolDirectory",
                component: <ProtocolDirectory {...props} />
            },
            {
                path: "ProtocolEdit",
                component: <ProtocolEdit {...props} />
            },
            {
                path: "WithdrawDepositAudit",
                component: <WithdrawDepositAudit {...props} />
            },
            {
                path: 'ReportListPage',
                component: <ReportListPage {...props} />
            },
            {
                path: 'ModelListPage',
                component: <ModelListPage {...props} />
            }
        ]
    }
};